import React from 'react'
import { Purchase } from '../../types'

import HoverTooltip from '../../../../../components/HoverTooltip'
import { CurrencyList } from '../types'

interface PurchaseStageCountProps {
    purchase: Purchase
    theme: string
    currencyList: CurrencyList[]
}

const formatNumber = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Разделяем тысячные пробелами
        .replace('.', ',') // Заменяем точку на запятую
}

const formatDateTime = (value: string | null | undefined) => {
    if (!value) {
        return {
            date: '',
            time: '',
        }
    }

    const date = new Date(value)

    return {
        date: date.toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }),
        time: date.toLocaleTimeString('ru-RU', {
            hour: '2-digit',
            minute: '2-digit',
        }),
    }
}

const PurchaseInfo: React.FC<PurchaseStageCountProps> = ({
    purchase,
    theme,
    currencyList,
}) => {
    // const currencyInfo = currencyList.find(
    //     (c) => Number(c.num_code) === Number(purchase.currency_digital_code)
    // )
    // const charSign =
    //     Number(purchase.currency_digital_code) !== 643
    //         ? (currencyInfo?.char_sign ?? '')
    //         : ''

    // // --- валютные вычисления ---
    // const isRub = Number(purchase.currency_digital_code) === 643
    // const currencyName = purchase.currency_name ?? ''
    // const rate =
    //     purchase.exchange_rate != null ? Number(purchase.exchange_rate) : null

    // // если rub_unit_price нет, но есть rate — посчитаем
    // const rubPrice =
    //     purchase.price != null
    //         ? Number(purchase.rub_price)
    //         : rate != null
    //           ? Number(purchase.price) * rate
    //           : null

    // const currecytooltip = (
    //     <>
    //         {!isRub ? (
    //             <div className="text-[12.8px]">
    //                 <div className="w-full text-left">{currencyName}</div>
    //                 {rate != null && (
    //                     <div className="opacity-80 w-full text-left">
    //                         Курс: {formatNumber(rate)}
    //                     </div>
    //                 )}
    //                 {/* {rubPrice != null && (
    //                     <div className="opacity-80 w-full text-left">
    //                         Цена (₽): {formatNumber(rubPrice)}
    //                     </div>
    //                 )} */}
    //             </div>
    //         ) : (
    //             <div className="text-[12.8px] opacity-90">{currencyName}</div>
    //         )}
    //     </>
    // )
    return (
        <>
            <div className="relative flex flex-row min-w-[1260px] max-w-[1710px] min-h-[80px] gap-2 bg-[#ebebeb] dark:bg-[#111111] items-start">
                <div className="flex flex-col flex-1 h-fit mx-2 py-2 items-start justify-start">
                    <div className="flex w-full h-fit items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Наименование закупки
                    </div>
                    <HoverTooltip
                        tooltipText={purchase.name ? purchase.name : '-'}
                    >
                        <div className="flex w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                            {purchase.name ? (
                                <p className="tworow">{purchase.name}</p>
                            ) : (
                                '-'
                            )}
                        </div>
                    </HoverTooltip>
                </div>
                <div className="flex flex-col w-[1px] h-[30px] mx-2 bg-[#b8b8b8] dark:bg-[#2A282B]"></div>
                <div className="flex flex-col w-[150px] h-fit mx-2 py-2 items-start justify-start">
                    <div className="flex w-full h-fit items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Сумма закупки
                    </div>
                    {/* <HoverTooltip
                        tooltipContent={currecytooltip}
                        align="right"
                        valign="bottom"
                    >
                        <div className="flex flex-col w-full h-full items-start justify-start text-xs">
                            <div className="flex w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                                {charSign + ' ' + formatNumber(purchase.price)}
                            </div>
                            {!isRub
                                ? rubPrice != null && (
                                      <div className="flex w-full h-full items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                                          ₽ {formatNumber(rubPrice)}
                                      </div>
                                  )
                                : ''}
                        </div>
                    </HoverTooltip> */}
                </div>
                <div className="flex flex-col w-[1px] h-[30px] mx-2 bg-[#b8b8b8] dark:bg-[#2A282B]"></div>
                <div className="flex flex-col w-[200px] h-full mx-2 py-2 items-start justify-start">
                    <div className="flex w-full h-fit items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Способ закупки
                    </div>
                    <div className="flex flex-col w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                        <HoverTooltip
                            tooltipText={
                                purchase.purchase_method_name
                                    ? purchase.purchase_method_name
                                    : '-'
                            }
                        >
                            <div className="flex w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                                {purchase.purchase_method_name ? (
                                    <p className="tworow">
                                        {purchase.purchase_method_name}
                                    </p>
                                ) : (
                                    '-'
                                )}
                            </div>
                        </HoverTooltip>
                    </div>
                </div>
                <div className="flex flex-col w-[1px] h-[30px] mx-2 bg-[#b8b8b8] dark:bg-[#2A282B]"></div>
                <div className="flex flex-col w-[150px] h-full mx-2 py-2 items-start justify-start">
                    <div className="flex w-full h-fit items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Статус размещения
                    </div>
                    <div className="flex flex-col w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                        <div>
                            {purchase.status == 'P'
                                ? 'Размещено'
                                : 'Не размещено'}
                        </div>
                        {purchase.publication_date_time ? (
                            <div className="flex flex-row w-full h-full gap-2 items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                                <div>
                                    {
                                        formatDateTime(
                                            purchase.publication_date_time
                                        ).date
                                    }
                                </div>
                                {/* <div>
                                    {
                                        formatDateTime(
                                            purchase.publication_date_time
                                        ).time
                                    }
                                </div> */}
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
                <div className="flex flex-col w-[1px] h-[30px] mx-2 bg-[#b8b8b8] dark:bg-[#2A282B]"></div>
                <div className="flex flex-col w-[150px] h-full mx-2 py-2 items-start justify-start">
                    <div className="flex w-full h-fit items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Реестровый номер в ЕИС
                    </div>
                    <div className="flex w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                        {purchase.registration_number
                            ? purchase.registration_number
                            : '-'}
                    </div>
                </div>
                <div className="flex flex-col w-[1px] h-[30px] mx-2 bg-[#b8b8b8] dark:bg-[#2A282B]"></div>
                <div className="flex flex-col w-[100px] h-full mx-2 py-2 items-start justify-start">
                    <div className="flex w-full h-fit items-start justify-start text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Версия
                    </div>
                    <div className="flex w-full h-full items-start justify-start text-xs text-[#181818] dark:text-[#FFFFFF]">
                        <p className="threerow">{purchase.version}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PurchaseInfo
